import { Helmet } from 'react-helmet-async';

const defaults = {
  siteName: 'Parcelin',
  baseUrl: 'https://parcelin.co.za',
  image: 'https://parcelin.co.za/logo.png',
  defaultTitle: 'Parcelin - Affordable Parcel Delivery South Africa | Same Day & Overnight Courier',
  defaultDescription: 'Send parcels across South Africa with Parcelin. Affordable same-day & overnight delivery from Gauteng to Limpopo. Save up to 60% on courier costs. Track your parcel in real-time.',
};

export default function SEO({ title, description, path, noIndex }) {
  const fullTitle = title ? `${title} | Parcelin` : defaults.defaultTitle;
  const desc = description || defaults.defaultDescription;
  const url = path ? `${defaults.baseUrl}${path}` : defaults.baseUrl;

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={desc} />
      <link rel="canonical" href={url} />

      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={desc} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={defaults.image} />
      <meta property="og:site_name" content={defaults.siteName} />
      <meta property="og:type" content="website" />
      <meta property="og:locale" content="en_ZA" />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={desc} />
      <meta name="twitter:image" content={defaults.image} />

      {noIndex && <meta name="robots" content="noindex, nofollow" />}
    </Helmet>
  );
}
